var runstatus_sr=0;
var index_sr_obj;
var s_status=1;

(function(global){
	"use strict";
	var srslide=function(){};
	
	srslide.prototype={
		options:{
			cur_num:0,
			per_width:$(".sr-index-1-box").width(),
			all_page:false,
			ele:'.sr-index-1-box',
			index_sr_obj:{},
			vis_num:1,
            last_width:0,
		},
		init:function(opts){
			var option=config(opts,this.options);			
			var _this=this;
			this.options=option;
			this.reData();
			
			$(window).resize(function(){
				window.clearTimeout(index_sr_obj);
				_this.reData();
			});
			
		},
		reData:function(){
			
			//初始化html
			
			var w=$(document).width();
			if(w<=566)
            {
              return false;
            }
			
			runstatus_sr=0;
			s_status=1;
		
			
			this.options['cur_num']=0;
			
			if(w>960)
			{
				this.options['vis_num']=3;
			}
			else if(w>566 && w<=960){
				this.options['vis_num']=2;
			}
			else{
				this.options['vis_num']=1;
			}
			
			var ele=$(this.options['ele']);
			
			var obj=ele.find(".sr-index-1");
			//loubo
			this.options['per_width']=ele.width()/this.options['vis_num'];//每个宽度
			this.options['last_width']=this.options['per_width']/2;//露出一点下一个产品
          
			ele.animate({'scrollLeft':'0px'},150);
			
			obj.width(obj.children("a").length*this.options['per_width']-(this.options['last_width'])*2);
			// obj.children("a").width(this.options['per_width']);
			
			var htmlstr="";
			// var total_sv=Math.ceil(obj.children("a").length/this.options['vis_num']);
			var total_sv=Math.ceil(obj.children("a").length-2);
			for(let sv=0;sv<total_sv; sv++)
			{
				if(sv==0)
				{
					htmlstr+='<span class="cur"></span>';
				}
				else{
					htmlstr+='<span></span>';
				}
				
			}
			$(".sr-slider-bar-3").html(htmlstr);
			
			var _this=this;
			
			
			
			var tiaojuang=function(i){
				
				if(runstatus_sr)
				{
					return false;
				}
				
				//var k=Math.floor(i/_this.options['vis_num']);
				var k=i;
				runstatus_sr=1;
				
				// ele.animate({'scrollLeft':(k*_this.options['per_width']*_this.options['vis_num'])+'px'},400,function(){
				ele.animate({'scrollLeft':(k*_this.options['per_width']-(_this.options['per_width']/2))+'px'},400,function(){
					runstatus_sr=0;
					//ele.find(".srslide-ele").find(".srslide-boxs").children(".lb-item").eq(k).addClass("cur").siblings().removeClass("cur"); 
					//var ssvv=Math.floor(k/_this.options['vis_num']);
					$(".sr-slider-bar-3 span").eq(k).addClass("cur").siblings().removeClass("cur");
					
				});
				_this.options['cur_num']=k;
				
			};
			
			//前跳
			$(".sr-slider-bar-3").children("span").hover(function(){
			
				var i=$(this).index();
				 
				tiaojuang(i);
				 
			},function(){});
			
			$(".sr-slider-bar-3").children("span").click(function(){
			
				var i=$(this).index();
				 
				tiaojuang(i);
				 
			});
			
			$(".sr-left").click(function(){
    			var i=$(".sr-slider-bar-3").find(".cur").index();
				i=i>1?i-1:0;
				tiaojuang(i);
			});

            $(".sr-right").click(function(){
      			var i=$(".sr-slider-bar-3").find(".cur").index();
						var j=$(".sr-slider-bar-3").children("span").length-1;
						if(j>i)
						{
							i++;
						}
						else{
							i=0;
						}
						
						tiaojuang(i);
			});
			
			
		}
		
		
		
	};
	
	function config(opts,options)
	{
		if(!opts) return options;
		for(var key in opts)
		{
			if(!!opts[key])
			{
				options[key]=opts[key];
			}
		}
		
		return options;
		
	}
	
	global.srslide = srslide;
	
}(this))

//loubo


var sr_index_slides=new srslide();

sr_index_slides.init({});




//-------------------------------下一个轮播
var runstatus=0;
var dhobj;
var s_status=1;
var systartPoint = null;
(function(global){
	"use strict";
	var ytm=function(){};
	
	ytm.prototype={
		options:{
			cur_num:0,
			per_width:$(".loubo").parent().width(),
			all_page:false,
			ele:'#xx',
			dhobj:{}
		},
		init:function(opts){
			var option=config(opts,this.options);			
			var _this=this;
			this.options=option;
			this.reData();
			
			$(window).resize(function(){
				window.clearTimeout(dhobj);
				_this.reData();
			});
			
		},
		reData:function(){
			var _this=this;
			//初始化html
			var w=$(".sr-newindex").width();
			runstatus=0;
			s_status=1;
		
			
			this.options['cur_num']=0;
			
			
			var ele=$(this.options['ele']);
			
			var obj=ele.find(".ytm-ele").find(".ytm-boxs");
            if(obj.children("a").length==1){
              return true;
            }
			//loubo
            ele.find(".ytm-ele").find(".ytm-boxs").children(".lb-item").eq(0).addClass("cur").siblings().removeClass("cur");
			ele.find(".lb-slbs").children("span").eq(0).addClass("cur").siblings().removeClass("cur");



          
			this.options['per_width']=ele.find(".ytm-ele").width();//每个宽度
			
			ele.find(".ytm-ele").animate({'scrollLeft':'0px'},150);
			
			$(".loubo .lb-main").width(obj.children(".lb-item").length*this.options['per_width']);
			obj.children(".lb-item").width(this.options['per_width']);
            
          
            var lazy_to_pimg=function(){
              obj.children(".lb-item").each(function(index,element){
              if(index>0){
                  
                  var img_url='';
                  
                  if(w>750){
                        img_url=$(element).find("a").find(".pc-img").data("src");
                        if(img_url){
                          $(element).find("a").find(".pc-img").attr("src",img_url).data("src","");
                        }
                        
                   }else{
                        img_url=$(element).find("a").find(".wap-img").data("src");
                        if(img_url){
                          $(element).find("a").find(".wap-img").attr("src",img_url).data("src","");
                        }
                        
                  }
                      
                      
                 
                 
              }
            });
            };
			window.setTimeout(lazy_to_pimg,1800);
			//向左
			ele.find(".left-btn").click(function(){
				if(runstatus)
				{
					return false;
				}

                
				var i=_this.options['cur_num'];
                
				if(_this.options['cur_num']>0)
				{
                 
    				window.clearTimeout(dhobj);
                    i--;
					i=i<0?0:i;
					tiaojuang(i);
				}
                
				
				 
			});
			
			//向右
			ele.find(".right-btn").click(function(){
				if(runstatus)
				{
					return false;
				}
				
				
				
				window.clearTimeout(dhobj);
				var i=_this.options['cur_num'];
				var j=obj.children(".lb-item").length-1;
				if(j>i)
				{
					i++;					
				}
				else{
					i=0;
				}
				tiaojuang(i);
				
				
				 
			});
			
			var tiaojuang=function(k){
				
				if(runstatus)
				{
					return false;
				}
				window.clearTimeout(dhobj);
				runstatus=1;
				_this.options['cur_num']=k;
				ele.find(".ytm-ele").animate({'scrollLeft':(k*_this.options['per_width'])+'px'},500,function(){
					runstatus=0;
					ele.find(".ytm-ele").find(".ytm-boxs").children(".lb-item").eq(k).addClass("cur").siblings().removeClass("cur");
					ele.find(".lb-slbs").children("span").eq(k).addClass("cur").siblings().removeClass("cur");
					dhobj=window.setTimeout(xunh,6500);			
					
				});
				
				
			};
			
			//前跳
			ele.find(".lb-slbs").children("span").hover(function(){
			
				var i=$(this).index();
				 
				tiaojuang(i);
				 
			},function(){});
			
			ele.find(".lb-slbs").children("span").click(function(){
			
				var i=$(this).index();
				 
				tiaojuang(i);
				 
			});
			
			
			//循环
			var xunh=function(){
				
				
				
				var i=ele.find(".lb-slbs").find(".cur").index();
				var j=ele.find(".lb-slbs").children("span").length;
				i++;
				if(i>=j)
				{
					i=0;
				}
				
				tiaojuang(i);
				
				
				
			};
			
			ele.hover(function(){
				s_status=0;
				//window.clearTimeout(dhobj);
			},function(){
				window.clearTimeout(dhobj);
				s_status=1;
				dhobj=window.setTimeout(xunh,5800);			
			});
			
			dhobj=window.setTimeout(xunh,8500);
			
			//-------------------------手机滑动
			systartPoint = null;
			if(w<=750)
            {
              document.getElementById("ppt").addEventListener("touchstart", function (e) {
				var e = e || window.event;
				systartPoint = e.touches[0];
    			},{passive:true});
			
			document.getElementById("ppt").addEventListener("touchend", function (e) {
            var e = e || window.event;
            //e.changedTouches能找到离开手机的手指，返回的是一个数组
            var endPoint = e.changedTouches[0];
            //计算终点与起点的差值
            var x = endPoint.clientX - systartPoint.clientX;
            var y = endPoint.clientY - systartPoint.clientY;
            //设置滑动距离的参考值
                   var d = 100;
            if (Math.abs(x) > d) {
                if (x > 0 && (y < 10 || y > 10)) {
                    //"向右滑动"
					
						var i=ele.find(".lb-slbs").find(".cur").index();
						i=i>1?i-1:0;
						tiaojuang(i);
					
					
					
                } else if (x < 0 && (y < 10 || y > 10)) {
                    //"向左滑动"
					
						var i=ele.find(".lb-slbs").find(".cur").index();
						var j=obj.children(".lb-item").length-1;
						if(j>i)
						{
							i++;
						}
						else{
							i=0;
						}
						
						tiaojuang(i);
						
					
                }
            }
            
        },{passive:true});

              
            }// end if
			
			
			
		}
		
		
		
	};
	
	function config(opts,options)
	{
		if(!opts) return options;
		for(var key in opts)
		{
			if(!!opts[key])
			{
				options[key]=opts[key];
			}
		}
		
		return options;
		
	}
	
	global.ytm = ytm;
	
}(this))

//loubo




var lbt=new ytm();

lbt.init({ele:'.loubo'});

function sr_vidSwap(idName,vidURL) {
var myVideo = document.getElementById(idName);
myVideo.src = vidURL;
myVideo.load();
myVideo.play();
}

if($(".loubo").width()<960 && $(".loubo").width()>100)
{
  $(".sr-index-video video").hide();//手机端移除视频
  
}
if($(".loubo").width()>750){
  //电脑端加载视频
  $(".sr-index-bg").hover(function(){
      var obj=$(this).next(".sr-index-video").find("video");
      if(obj.data("sp")==0)
      {
      	var id=obj.attr("id");
         obj.data("sp",1);
      
    	if(id == "sr_sp_1")
    	{
    		sr_vidSwap("sr_sp_1","https://cdn.shopify"+".com/videos/c/o/v/886dc50f4a27488abca927e63d1eb004.mp4");//不这样处理,url会被替换成net 导致国内访问不了
    	}
    	else if(id == "sr_sp_2")
    	{
    		sr_vidSwap("sr_sp_2","https://cdn.shopify"+".com/videos/c/o/v/be40ed3261f04f65830518eed04f8d89.mp4");
           
            window.setTimeout(function(){ $("#sr_sp_2").css("bottom","30px");},4800);
    	}
    	else if(id == "sr_sp_3")
    	{
    		sr_vidSwap("sr_sp_3","https://cdn.shopify"+".com/videos/c/o/v/6abb45e6265b483395633ede0bea9235.mp4");
    	}
	
    }

    
  });
 
  ///
}


var scroll_first=0;
var scroll_second=0;
function sr_lazy_loadimg(j)
{
    $(".sirui-loading-img"+j).each(function(){
        var iurl=$(this).data("src");
        if(iurl)
        {
          $(this).attr("src",iurl);
          $(this).data("src","");
        }
        
    });
  
    if($(".loubo").width()>=1080 && !j){
      
    }
    else if($(".loubo").width()<=656 && !j){
      $(".sr-bware-box").css("background","url(https://cdn.shopify.com/s/files/1/0449/9344/6037/t/13/assets/750x350-1672126362274.jpg?v=1672126364) no-repeat right bottom").css('background-size','100% 100%');
      $(".sr-index-spp-1").css("background","url(https://cdn.shopifycdn.net/s/files/1/0449/9344/6037/files/35_7470309f-9811-434d-88d4-12a939e0f79d.jpg?v=1678343793) no-repeat center").css('background-size','100% auto');
      $(".sr-index-spp-2").css("background","url(https://cdn.shopify.com/s/files/1/0449/9344/6037/t/13/assets/a100bcjwap-1677745376944.jpg?v=1677745377) no-repeat center").css('background-size','100% auto');
      $(".sr-index-spp-3").css("background","url(https://cdn.shopify.com/s/files/1/0449/9344/6037/t/13/assets/srnew_jiajia-1672106143282.jpg?v=1672106146) no-repeat center").css('background-size','100% auto');
    }
}


$(document).scroll(function(){
  var i=$(document).scrollTop();
  if(i>20 && scroll_first==0)
  {
    scroll_first=1;
    sr_lazy_loadimg('');
  }
  else if(i>100 && scroll_second==0)
  {
    scroll_second=1;
    sr_lazy_loadimg('2');
  }
  
});

$(".sale-collections-links").click(function(){
  location.href="https://store.sirui.com/collections/on-sale";
});

$("#new-class-box2-content-input-button-btn").click(function() {
  $.post( "https://cf.sirui.com/index/shopify/submitContact", { contact: $("#new-class-box2-content-input-email").val() } )
    .done(function( data ) {
      if (data['code'] === 0) {
        alert("5% off First Order Coupon：NEW")
      } else {
        alert(data['msg'])
      }
  });
})



    $('.show-recom2').scroll(function() {
        var scrollPercentage = 100 * this.scrollLeft / (this.scrollWidth-this.clientWidth);
        $('.show-recom2-body-jdt-box-add').css('width', scrollPercentage.toFixed(2)+'%');
    });

    $(document).ready(function(){
        $(".show-recom-box-d").hover(
            function(){
                if ($(this).hasClass('is_change_recom')) {
                    return;
                }
                $('.img-get-width').css({'border-radius': '15px'})
                $('.is_change_show_type').removeClass('show-recom-box-d-change-add-class');
                $(".is_change_recom").stop(true, true).animate({width: '12.5%'}, 600,'swing');
                $(".is_change_recom").stop(true, true).removeClass('is_change_recom');
                $('.show-recom-box-d-change').css({width: '0px'});
                $(this).addClass('is_change_recom');
                $(this).css({width: '50%'});
                $(this).find('.img-get-width').css({'border-radius': '15px 0 0 15px'});
                // $(this).find('.show-recom-box-d-change').animate({width: '78%'}, "slow");
                $(this).find('.show-recom-box-d-change').css({width: '78%'});
                $(this).addClass('is_change_recom');
                $(this).find('.is_change_show_type').addClass('show-recom-box-d-change-add-class');
                // 鼠标悬停时执行的操作
            },
            function(){
                // 鼠标离开时执行的操作
            }
        );
    });






    $('.bannerPosition').each(function (index, item){
        $(this).attr('bannerPosition_size', $(this).find('.new-index-banner-list div').length)
        $(this).attr('bannerPosition_width', $(this).find('.new-index-banner-list div').outerWidth())
        $(this).find('.new-index-banner-list').css({
            left: -($(this).find('.new-index-banner-list div').outerWidth())
        })
    })

    // 右按钮事件
    $('.bannerPosition .new-index-banner-next').click(function () {
        $(this).parent().parent().attr('index', parseInt($(this).parent().parent().attr('index')) + 1)
        getBannerScroll( $(this).parent().parent())
    })
    // 左按钮
    $('.bannerPosition .new-index-banner-prev').click(function () {
        $(this).parent().parent().attr('index', parseInt($(this).parent().parent().attr('index')) - 1)
        getBannerScroll($(this).parent().parent())
    })

    // 图片滑动逻辑
    function getBannerScroll(index_target) {
        var data_list = index_target.find('.new-index-banner-list');
        var index_num = parseInt(index_target.attr('index'));
        var bannerPosition_size = index_target.attr('bannerPosition_size');
        var bannerPosition_width = index_target.attr('bannerPosition_width');
        data_list.animate({
            left: -index_num * bannerPosition_width
        })
        var dot_index = index_num;
        if (index_num >= bannerPosition_size - 1) {
            data_list.animate({
                left: -bannerPosition_width
            }, 0)
            index_target.attr('index', 1)
            dot_index = 1;
        }
        if (index_num < 1) {
            data_list.animate({
                left: -bannerPosition_width * (bannerPosition_size - 2)
            }, 0)
            index_target.attr('index', (bannerPosition_size - 2))
        }
        index_target.find('.new-index-banner-dot span').eq(dot_index - 1).addClass('new-index-banner-active').siblings().removeClass('new-index-banner-active')
    }

    // 左右滑动事件
    $(document).ready(function() {
        var startX, startY, endX, endY;
        $(".bannerPosition .new-index-banner-list").on("touchstart", function(event) {
            startX = event.originalEvent.changedTouches[0].pageX;
            startY = event.originalEvent.changedTouches[0].pageY;
        });
        $(".bannerPosition .new-index-banner-list").on("touchmove", function(event) {
            endX = event.originalEvent.changedTouches[0].pageX;
            endY = event.originalEvent.changedTouches[0].pageY;
        });
        $(".bannerPosition .new-index-banner-list").on("touchend", function(event) {
            if (endX< startX) {

                $(this).parent().attr('index', parseInt($(this).parent().attr('index')) + 1)
                getBannerScroll($(this).parent())
            } else if (endX > startX) {
                $(this).parent().attr('index', parseInt($(this).parent().attr('index')) - 1)
                getBannerScroll($(this).parent())
            }
        });
    });

    // 重置图片尺寸
    $(window).resize(function(){
        $('.bannerPosition').each(function (index, item){
            $(this).attr('bannerPosition_size', $(this).find('.new-index-banner-list div').length)
            $(this).attr('bannerPosition_width', $(this).find('.new-index-banner-list div').outerWidth())
            $(this).find('.new-index-banner-list').css({
                left: -($(this).find('.new-index-banner-list div').outerWidth())
            })
        })
    });